<template>
	<div id="mailing_registry_input" class="mailing_registry" style="display:block">
		<div class="mb-3 flex-row">
			<div class="mb-3 flex-row">
                <div class="title-block__left">
                    <div class="title-block__title">Реестр отправлений</div>
                </div>
				<a class="title-block__btn btn-add btn-primary btn" :href="route_page_create">Добавить письмо</a>
			</div>
		</div>

		<div class="mailing_registry__input mb-3">
			<div class="mailing_registry__search-input">
				<div class="filter-table__input-wrap search-control">
					<input @keyup.enter="onSearch()" @keyup.delete="onDeleteSearch()" type="text" v-model="search" class="search-control__input form-control" placeholder="Поиск">
					<button @click="onSearch()" class="search-control__input-btn reset-btn">
						<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z" fill="currentColor"></path>
						</svg>
					</button>
				</div>
                <FilterComponent
                    :filters="filter"
                    @filterApplied="handleFilterData"
                />
			</div>
		</div>

		<table class="service-table table align-middle">
			<thead>
				<tr>
					<th class="va-middle" scope="col" v-for="elem in thead" :key="elem">
						<div class="th-inner sortable asc"
							:class="{'actions-row-label': elem === 'Действия' || elem === 'Статус отправки'}">
							{{ elem }}
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(row, index) in tbody" :key="index">
					<td class="va-middle">{{ row.tbody.name }}</td>
                    <td class="va-middle">{{ row.tbody.sending_type }}</td>
					<td class="va-middle">{{ row.tbody.letter_subject }}</td>
					<td class="va-middle">
                        <div class="letter-groups">
                            <div class="table-popup__btn" @click="showLetterGroupsModal(row.tbody.letter_groups)">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.49982 17.5V15.8333C2.49982 14.9493 2.85101 14.1014 3.47613 13.4763C4.10125 12.8512 4.9491 12.5 5.83315 12.5H9.16648C10.0505 12.5 10.8984 12.8512 11.5235 13.4763C12.1486 14.1014 12.4998 14.9493 12.4998 15.8333V17.5M13.3331 2.60834C14.0502 2.79192 14.6857 3.20892 15.1395 3.7936C15.5934 4.37827 15.8397 5.09736 15.8397 5.8375C15.8397 6.57765 15.5934 7.29674 15.1395 7.88141C14.6857 8.46609 14.0502 8.88309 13.3331 9.06667M17.4998 17.5V15.8333C17.4956 15.0976 17.2481 14.384 16.7959 13.8037C16.3437 13.2233 15.7122 12.8089 14.9998 12.625M4.16648 5.83333C4.16648 6.71739 4.51767 7.56523 5.14279 8.19036C5.76792 8.81548 6.61576 9.16667 7.49982 9.16667C8.38387 9.16667 9.23172 8.81548 9.85684 8.19036C10.482 7.56523 10.8332 6.71739 10.8332 5.83333C10.8332 4.94928 10.482 4.10143 9.85684 3.47631C9.23172 2.85119 8.38387 2.5 7.49982 2.5C6.61576 2.5 5.76792 2.85119 5.14279 3.47631C4.51767 4.10143 4.16648 4.94928 4.16648 5.83333Z" stroke="#242731" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                    </td>
                    <td class="va-middle">{{ row.tbody.letter_sender_name }}</td>
					<td class="va-middle">
						<div :class="{'letter-status': true}" v-bind:class="'letter-status' + row.tbody.status_color">
							{{ row.tbody.status_title }}
						</div>
					</td>
					<td class="va-middle">{{ row.tbody.date_sending }}</td>
					<td class="va-middle">
						<div class="table-action-buttons">
							<a :href="route_preview + row.id" target="_blank" class="table-action table-action_preview m-auto align-middle" title="Предпросмотр"></a>
							<a v-if="row.tbody.allow_edit" :href="route_page_edit + row.id" class="table-action table-action_edit m-auto align-middle" title="Редактировать"></a>
							<a :href="route_page_create" @click="clone(row.id)" class="table-action table-action_copy m-auto align-middle" title="Клонировать"></a>
							<button @click="copySource(row.tbody.letter_body)" class="table-action table-action_html m-auto align-middle" title="Скопировать исходный код в буфер обмена"></button>
							<button @click="deleteTemplate(row.id)" class="table-action table-action_delete m-auto align-middle" title="Удалить"></button>
						</div>
					</td>
				</tr>
			</tbody>
		</table>

        <Alert />

        <LettersMailingsGroupsModal
            v-if="lettersGroupsModal"
            :modalTitle="'Группы и Email адреса получателей'"
            :groups="lettersGroups"
            @closeModal="closeLetterGroupsModal"
        />

		<pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
	</div>
</template>

<script>
	import Mailings from '../../../../models/Mailings/Mailings';
    import PaginationElement from '../../../../elements/PaginationElement.vue';
    import axios from 'axios';
    import FilterComponent from "../../../../elements/FilterComponent.vue";
    import { mapState } from 'vuex/dist/vuex.cjs.js';
    import { mapMutations } from 'vuex/dist/vuex.cjs.js';
    import Alert from '../../../alerts/Alert.vue';
    import LettersMailingsGroupsModal from "../../../../modals/LettersMailingsGroupsModal.vue";

    export default {
		name: 'MailingRegistryComponent',
        components: {LettersMailingsGroupsModal, Alert, PaginationElement, FilterComponent},
        props: {
            route_list: String,
            route_page_create: String,
            route_page_edit: String,
            route_delete: String,
            route_preview: String,
            route_clone_mailing: String,
            route_senders: String,
            route_statuses: String,
        },
		data() {
			return {
                mailing: new Mailings({
                    route_list: this.route_list,
                    route_delete: this.route_delete,
                }),
                count: 1,
                limit: 30,
                page: 1,
                search: '',
                sender: null,
                status: null,
                selectedSender: null,
                selectedStatus: null,
                thead: [
                    'Название письма',
                    'Тип отправки',
                    'Тема письма',
                    'Получатели',
                    'Отправитель',
                    'Статус отправки',
                    'Дата и время отправки',
                    'Действия'
                ],
				tbody: [],
				checkedItems: [],
                senders: [],
                statuses: [],

                lettersGroupsModal: false,
                lettersGroups: [],

			};
		},
		computed: {
            ...mapState('filterComponent', ['filterState']),
			isAllSelected() {
				return this.checkedItems.length === this.tbody.length && this.checkedItems.every(item => item);
			},
            filter() {
                return [
                    {
                        type: 'select',
                        name: 'Отправитель',
                        model: this.selectedSender,
                        options: this.senders,
                    },
                    {
                        type: 'select',
                        name: 'Статус',
                        model: this.selectedStatus,
                        options: this.statuses,
                    }
                ];
            }
		},
		methods: {
            ...mapMutations('alerts', ['addAlert']),
            ...mapMutations('mailings', ['setMailingInfo']),
            loadTable: async function () {
                // Формируем объект params с фильтрами по id
                const params = {};
                if (this.selectedSender) params.sender_id = this.selectedSender;
                if (this.selectedStatus) params.status = this.selectedStatus;

                const response = await this.mailing.loadTable(
                    this.page,
                    this.limit,
                    this.search,
                    JSON.stringify(params)
                );

                this.tbody = response.tbody;
                this.count = response.pages;
            },
            async loadStatus() {
                await axios.get(this.route_statuses)
                    .then(response => {
                        this.statuses = Object.entries(response.data)
                            .map(([name, id]) => ({id, name}));
                    })
                    .catch(error => {
                        console.log('Ошибка загрузки статусов:', error);
                    })
            },
            async loadSenders() {
                await axios.get(this.route_senders)
                    .then(response => {
                        this.senders = Object.entries(response.data)
                            .map(([name, id]) => ({name, id}));
                    })
                    .catch(error => {
                        console.log('Ошибка загрузки отправителей:', error);
                    })
            },
            toggleAll(event) {
				const isChecked = event.target.checked;
				this.checkedItems = this.tbody.map(() => isChecked);
			},
            pageChange(newPage) {
                this.page = newPage;
                this.loadTable();
            },
            clone(id) {
                const mailing = this.tbody.find(el => el.id === id).tbody;
                this.setMailingInfo(mailing);
                localStorage.setItem('mailingId', id)
            },
            copySource: async function (source) {
                await navigator.clipboard.writeText(source);
                this.addAlert({ type: 'success', title: 'Успешно', text: 'Исходный код письма скопирован в буфер обмена' });
            },
            deleteTemplate: function (id) {
                let conf = confirm('Вы уверены что хотите удалить?');
                if(!conf) {
                    return;
                }
                if (conf) {
                    this.mailing.delete(id).then(this.loadTable);
                }
            },
            onSearch: function () {
                this.page = 1;
                this.loadTable();
            },
            onDeleteSearch: async function () {
                if (this.search.trim() === '') {
                    this.page = 1;
                    await this.loadTable()
                }
            },
            handleFilterData(data) {
                this.selectedSender = data.selectedSender ?? null;
                this.selectedStatus = data.selectedStatus ?? null;
                this.page = 1;
                this.loadTable();
            },
            showLetterGroupsModal(groups) {
                this.lettersGroupsModal = true;
                this.lettersGroups = groups;
            },
            closeLetterGroupsModal() {
                this.lettersGroupsModal = false;
            },
            checkNoRecievers() {
                if (localStorage.getItem('noRecievers')) {
                    this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Письмо / рассылка создана без получателей. Добавьте адресатов, чтобы отправить письмо.' });
                    localStorage.removeItem('noRecievers');
                }
            }
		},
		mounted() {
            this.checkNoRecievers();
            this.loadTable();
            this.loadStatus();
            this.loadSenders();
			this.checkedItems = this.tbody.map(() => false);
		}
	};
</script>

<style scoped lang="scss">
	.page-label {
		font-size: 18px;
		font-weight: 600;
	}
	.mailing_registry {
		margin: 0px 0px 20px 0px;
		&__input {
			display: flex;
			justify-content: space-between;
		}
		&__search-input {
			display: flex;
			flex-direction: row;
			align-items: center;
			gap: 16px;
			flex: 3;
		}
		&__input-btns {
			display: flex;
			flex-direction: row;
			justify-content: flex-end;
			gap: 16px;
			flex: 2;
		}
	}
	.letter-status {
		text-align: center;
		padding: 6px;
		border-radius: 6px;
		&__sent {
			background-color: #D4F8D3;
		}
		&__waiting {
			background-color: #D8EBFF;
		}
		&__error {
			background-color: #FBE7E9;
		}
	}
    .letter-groups {
        display: flex;
        gap: 12px;
        justify-content: center
    }
	.actions-row-label {
		text-align: center;
	}
	.va-middle {
		vertical-align: middle;
	}
	.flex-row {
		display: flex;
		flex-direction: row;
		gap: 20px;
	}
	.table-action-buttons {
		display: flex;
		gap: 10px;
	}
	.hidden {
		display: none;
	}
	.visible {
		display: block;
	}
    .table-popup {
        &__btn {
            display: flex;
            gap: 6px;
            background-color: #F1F6FF;
            border-radius: 4px;
            padding: 4px 6px;
            cursor: pointer;
        }
        &__check {
            @extend .table-popup__btn;
            background-color: white;
            cursor: default;
        }
    }
</style>
